var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGameIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 30,
    viewBox: "0 0 50 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4932 28.9779C23.3158 27.8886 26.6842 27.8886 29.5068 28.9779C31.2168 29.6378 33.0761 30 35 30C43.2843 30 50 23.2843 50 15C50 6.71573 43.2843 0 35 0L15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30C16.9239 30 18.7832 29.6378 20.4932 28.9779ZM17.5029 9.37405C17.5029 7.99334 16.3836 6.87405 15.0029 6.87405C13.6222 6.87405 12.5029 7.99334 12.5029 9.37405L12.5029 12.5001L9.37717 12.5001C7.99646 12.5001 6.87717 13.6194 6.87717 15.0001C6.87717 16.3809 7.99646 17.5001 9.37717 17.5001H12.5029V20.6241C12.5029 22.0048 13.6222 23.1241 15.0029 23.1241C16.3836 23.1241 17.5029 22.0048 17.5029 20.6241V17.5001H20.6272C22.0079 17.5001 23.1272 16.3809 23.1272 15.0001C23.1272 13.6194 22.0079 12.5001 20.6272 12.5001H17.5029V9.37405ZM35.0014 12.4996C36.3822 12.4996 37.5014 11.3804 37.5014 9.99964C37.5014 8.61893 36.3822 7.49964 35.0014 7.49964C33.6207 7.49964 32.5014 8.61893 32.5014 9.99964C32.5014 11.3804 33.6207 12.4996 35.0014 12.4996ZM30.0029 17.4995C31.3836 17.4995 32.5029 16.3803 32.5029 14.9995C32.5029 13.6188 31.3836 12.4995 30.0029 12.4995C28.6222 12.4995 27.5029 13.6188 27.5029 14.9995C27.5029 16.3803 28.6222 17.4995 30.0029 17.4995ZM42.5018 15.0014C42.5018 16.3821 41.3825 17.5014 40.0018 17.5014C38.6211 17.5014 37.5018 16.3821 37.5018 15.0014C37.5018 13.6206 38.6211 12.5014 40.0018 12.5014C41.3825 12.5014 42.5018 13.6206 42.5018 15.0014ZM35.0014 22.5008C36.3822 22.5008 37.5014 21.3815 37.5014 20.0008C37.5014 18.6201 36.3822 17.5008 35.0014 17.5008C33.6207 17.5008 32.5014 18.6201 32.5014 20.0008C32.5014 21.3815 33.6207 22.5008 35.0014 22.5008Z",
    fill: "url(#paint0_linear_616_12988)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_616_12988",
    x1: 0,
    y1: 0,
    x2: 52.1301,
    y2: 4.3248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameIcon1);
export default __webpack_public_path__ + "static/media/game-icon1.4e730350e40e91e0e32c214fcaf477d5.svg";
export { ForwardRef as ReactComponent };